import { CreateShopTransactionAccess } from "../../types";

export const defaultValues = (data?: CreateShopTransactionAccess) => {
  return {
    shop_transaction_id: data?.shop_transaction?.shop_transaction_id ?? "",
    job_position_id: data?.job_position?.job_position_id ?? ""
  };
};